import React from 'react';
import { Link, useForm } from '@inertiajs/react';
import { Alert } from '../../components/Alert';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import ValidationError from '../../components/ValidationError';
import { useTrans } from '../../hooks/useTrans';
import AuthPanel from '../../components/layout/auth/AuthPanel';

export default function ResetPassword({ token, email, flash }) {
    const translate = useTrans();

    const { data, setData, post, processing, errors } = useForm({
        token: token ?? '',
        email: email ?? '',
        password: '',
        password_confirmation: '',
    });

    function handleSubmit(e) {
        e.preventDefault();
        post('/reset/password');
    }

    return (
        <>
            <AuthPanel>
                <h5 className="text-lg font-bold text-[#003545]">
                    {translate('Wachtwoord veranderen')}
                </h5>
                <hr className="my-4 border-[#dfdfdf]" />

                {flash && flash.type === 'error' && (
                    <Alert variant="error">{flash.description}</Alert>
                )}

                <form onSubmit={handleSubmit} autoComplete="off">
                    <div className="space-y-4">
                        <div>
                            <label className="block text-sm font-bold text-[#003545] mb-1">
                                {translate('Wachtwoord')}
                            </label>
                            <Input
                                type="password"
                                value={data.password}
                                onChange={(e) => setData('password', e.target.value)}
                                autoFocus
                                className="h-[44px] font-normal"
                            />
                            <ValidationError message={errors.password} />
                        </div>

                        <div>
                            <label className="block text-sm font-bold text-[#003545] mb-1">
                                {translate('Herhaal wachtwoord')}
                            </label>
                            <Input
                                type="password"
                                value={data.password_confirmation}
                                onChange={(e) => setData('password_confirmation', e.target.value)}
                                className="h-[44px] font-normal"
                            />
                            <ValidationError message={errors.password_confirmation} />
                        </div>

                        <Button variant="primary" type="submit" disabled={processing} className="w-full">
                            {translate('Wachtwoord bijwerken')}
                        </Button>
                    </div>
                </form>
            </AuthPanel>

            <Link href="/login" className="mt-4 block text-center text-sm text-white/60 no-underline hover:text-white">
                {translate('Annuleren')}
            </Link>
        </>
    );
}
